<div class="arrow-button relative center-children" [class]="{'rotated-180': rotated, 'outline': outline, 'disabled': disabled}">
  <app-icon type="arrow-left"></app-icon>
</div>
